<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show">
                        <v-toolbar dark color="blue">
                            <v-toolbar-title class="my-0 py-0">Nueva Obligación Periódica Legal o de Otro
                                Tipo</v-toolbar-title>
                            <v-spacer></v-spacer>
                            Código: {{ codgral }}
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="blue lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="2">
                                    <v-select dense v-model="aspecto" :items="aspectos" label="Aspecto"
                                        item-text="detalle" item-value="valor"></v-select>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field label="Obligación" dense v-model="obligacion">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-select dense v-model="tipo" :items="tipos" label="Tipo" item-text="detalle"
                                        item-value="valor"></v-select>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-select dense v-model="alcance" :items="alcances" label="Alcance"
                                        item-text="detalle" item-value="valor"></v-select>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Norma" dense v-model="norma">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Título" dense v-model="titulo">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Localización" dense v-model="localizacion">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Materia" dense v-model="materia">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Frecuencia" dense v-model="frecuencia">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Fecha últ. actualización" dense v-model="fecha">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    <v-select dense v-model="resp" :items="responsables" label="Responsable"
                                        item-text="detalle" item-value="valor"></v-select>
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Norma Técnica" dense v-model="normatec">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    <v-select dense v-model="estado" :items="estados" label="Estado" item-text="detalle"
                                        item-value="valor"></v-select>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-textarea label="Observaciones" dense rows="2" auto-grow v-model="observ">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card v-if="tramites.length > 0">
                        <v-card-subtitle>
                            Obligación en Trámite
                        </v-card-subtitle>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        Fecha
                                                    </th>
                                                    <th class="text-left">
                                                        Observaciones
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in tramites" :key="item.id">
                                                    <td>{{ item.fecha }}</td>
                                                    <td>
                                                        <div class="multi-line">{{ item.observ }}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card v-if="historial.length > 0">
                        <v-card-subtitle>
                            Historial
                        </v-card-subtitle>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        Fecha cumplimiento
                                                    </th>
                                                    <th class="text-left">
                                                        Fecha vencimiento
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in historial" :key="item.id">
                                                    <td>{{ item.fecha }}</td>
                                                    <td>{{ item.fechavenc }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<style scoped>
.align-textarea {
    padding-top: 12px !important;
    /* ajusta el valor según necesites */
}
</style>
<script>
import axios from "../../../axios-auth.js";
import moment from "moment";
export default {
    data: (vm) => ({
        lazy: false,
        valid: false,
        resp: "",
        aspecto: "",
        obligacion: "",
        estado: "A",
        norma: "",
        normatec: "",
        alcance: "",
        fecha: "",
        fechavenc: "",
        frecuencia: "",
        titulo: "",
        localizacion: "",
        materia: "",
        observ: "",
        tipo: "",
        tramite: "",
        fechatramite: "",
        fechaverif: "",
        observtramite: "",
        tramites: [],
        historial: [],
        deshabilitar: false,
        estados: [{ detalle: "Activa", valor: "A" },
        { detalle: "Inactiva", valor: "I" },
        ],
        tipos: [{ detalle: "Legal", valor: "L" },
        { detalle: "Registro", valor: "R" },
        { detalle: "Otro", valor: "O" },
        ],
        alcances: [{ detalle: "Nacional", valor: "Nacional" },
        { detalle: "Provincial", valor: "Provincial" },
        { detalle: "Municipal", valor: "Municipal" },
        { detalle: "Nacional, Provincial y Municipal", valor: "Nacional, Provincial y Municipal" },
        ],
        aspectos: [{ detalle: "Medio Ambiente", valor: "M" },
        { detalle: "SST", valor: "S" },
        { detalle: "Clientes y Registros", valor: "C" },
        { detalle: "Legales y Societarios", valor: "L" },
        { detalle: "Otros", valor: "O" },
        ],
        responsables: [{ detalle: "AGNOLON Fernando", valor: "AGNOLON Fernando" },
        { detalle: "BLANCO Sergio", valor: "BLANCO Sergio" },
        { detalle: "DEMICHELIS Leonardo", valor: "DEMICHELIS Leonardo" },
        { detalle: "GRUBESIC Monica", valor: "GRUBESIC Monica" },
        { detalle: "MANSUR Cecilia", valor: "MANSUR Cecilia" },
        { detalle: "MOLINARI Marcelo", valor: "MOLINARI Marcelo" },
        { detalle: "MONTENEGRO Sonia", valor: "MONTENEGRO Sonia" },
        { detalle: "MUSSO Marcos", valor: "MUSSO Marcos" },
        { detalle: "OFICINA DE PERSONAL", valor: "OFICINA DE PERSONAL" },
        { detalle: "PRIETO Maria Luisa", valor: "PRIETO Maria Luisa" },
        ],

    }),
    props: ["visible", "codgral"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarobligacion();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargarobligacion() {
            let self = this;
            axios
                .get("/Sgi/Cargarobligacion?", {
                    params: {
                        codgral: self.codgral,
                    },
                })
                .then((response) => {
                    self.alcance = response.data.alcance;
                    self.aspecto = response.data.aspecto;
                    self.obligacion = response.data.obligacion;
                    self.titulo = response.data.titulo;
                    self.materia = response.data.materia;
                    self.tipo = response.data.tipo;
                    self.fecha = response.data.fecha;
                    self.norma = response.data.norma;
                    self.normatec = response.data.normatec;
                    self.localizacion = response.data.localizacion;
                    self.estado = response.data.estado;
                    self.resp = response.data.responsable;
                    self.frecuencia = response.data.frecuencia;
                    self.observ = response.data.observ;
                    self.tramite = response.data.tramite;
                    self.tramites = response.data.tramites;
                    self.historial = response.data.historial;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        vaciarModels() {
            this.resp = "";
            this.aspecto = "";
            this.obligacion = "";
            this.estado = "A";
            this.norma = "";
            this.normatec = "";
            this.alcance = "";
            this.fecha = "";
            this.frecuencia = "";
            this.titulo = "";
            this.localizacion = "";
            this.materia = "";
            this.observ = "";
            this.tipo = "";
            this.fechatramite = "";
            this.fechaverif = "";
            this.observtramite = "";
            this.tramites = [];
            this.historial = [];
            this.deshabilitar = false;
        },
    },
}
</script>
